import { motion } from 'framer-motion';
import { Box, BoxProps } from '@chakra-ui/layout';

const MotionBox = motion<BoxProps>(Box);
export default MotionBox;
